import axios from "axios";

export default axios.create({
  baseURL: process.env.REACT_APP_API_HOST,
  auth: {
    username: "nimbleauth",
    password: "G8)tg14q",
  },
});


export const axiosV2 = axios.create({
  baseURL: process.env.REACT_APP_API_HOST_V2,
  auth: {
    username: "nimbleauth",
    password: "G8)tg14q",
  },
});